import {
	DanThuocItemResponse,
	fa_danthuoc,
	fa_danthuoc_chitiet,
	fa_danthuoc_hinhanh
} from '../../../models/response/y-te/fa_danthuoc';

export enum eDanThuocActionTypeIds {
	LOAD_START = "DAN_THUOC_LOAD_START",
	LOAD_SUCCESS = "DAN_THUOC_LOAD_SUCCESS",
	LOAD_ERROR = "DAN_THUOC_LOAD_ERROR",

	LOAD_DETAIL_START = "DAN_THUOC_LOAD_DETAIL_START",
	LOAD_DETAIL_SUCCESS = "DAN_THUOC_LOAD_DETAIL_SUCCESS",
	LOAD_DETAIL_ERROR = "DAN_THUOC_LOAD_DETAIL_ERROR",

	SHOW_DETAIL = "DAN_THUOC_SHOW_DETAIL",
	CLOSE_DETAIL = "DAN_THUOC_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "DAN_THUOC_CHANGE_SELECTED_IDS",
	CHANGE_SELECTED_ID = "DAN_THUOC_CHANGE_SELECTED_ID",

	SHOW_CONFIRM = "DAN_THUOC_SHOW_CONFIRM",
	CLOSE_CONFIRM = "DAN_THUOC_CLOSE_CONFIRM",

	SAVE_START = "DAN_THUOC_SAVE_START",
	SAVE_SUCCESS = "DAN_THUOC_SAVE_SUCCESS",
	SAVE_ERROR = "DAN_THUOC_SAVE_ERROR",

	DELETE_START = "DAN_THUOC_DELETE_START",
	DELETE_SUCCESS = "DAN_THUOC_DELETE_SUCCESS",
	DELETE_ERROR = "DAN_THUOC_DELETE_ERROR",

	CAPNHAT_XULY_START = "DAN_THUOC_CAPNHAT_XULY_START",
	CAPNHAT_XULY_SUCCESS = "DAN_THUOC_CAPNHAT_XULY_SUCCESS",
	CAPNHAT_XULY_ERROR = "DAN_THUOC_CAPNHAT_XULY_ERROR",

	LOAD_CHITIET_START = "DAN_THUOC_LOAD_CHITIET_START",
	LOAD_CHITIET_SUCCESS = "DAN_THUOC_LOAD_CHITIET_SUCCESS",
	LOAD_CHITIET_ERROR = "DAN_THUOC_LOAD_CHITIET_ERROR",

	SHOW_CHITIET_DETAIL = "DAN_THUOC_SHOW_CHITIET_DETAIL",
	CLOSE_CHITIET_DETAIL = "DAN_THUOC_CLOSE_CHITIET_DETAIL",

	SAVE_CHITIET_START = "DAN_THUOC_SAVE_CHITIET_START",
	SAVE_CHITIET_SUCCESS = "DAN_THUOC_SAVE_CHITIET_SUCCESS",
	SAVE_CHITIET_ERROR = "DAN_THUOC_SAVE_CHITIET_ERROR",

	SHOW_CHITIET_CONFIRM = "DAN_THUOC_SHOW_CHITIET_CONFIRM",
	CLOSE_CHITIET_CONFIRM = "DAN_THUOC_CLOSE_CHITIET_CONFIRM",

	DELETE_CHITIET_START = "DAN_THUOC_DELETE_CHITIET_START",
	DELETE_CHITIET_SUCCESS = "DAN_THUOC_DELETE_CHITIET_SUCCESS",
	DELETE_CHITIET_ERROR = "DAN_THUOC_DELETE_CHITIET_ERROR",

	LOAD_HINHANH_START = "DAN_THUOC_LOAD_HINHANH_START",
	LOAD_HINHANH_SUCCESS = "DAN_THUOC_LOAD_HINHANH_SUCCESS",
	LOAD_HINHANH_ERROR = "DAN_THUOC_LOAD_HINHANH_ERROR"
}

/** Payload của `capnhat-xuly` / `capnhat-chuaxuly` — backend nhận `List<int>` */
export interface IDanThuocCapNhatXuLyPayload {
	ids: number[],
	da_xu_ly: boolean
}

export interface IDanThuocLoadStart {
	type: eDanThuocActionTypeIds.LOAD_START,
	payload: number
}
export interface IDanThuocLoadSuccess {
	type: eDanThuocActionTypeIds.LOAD_SUCCESS,
	payload: DanThuocItemResponse[]
}
export interface IDanThuocLoadErr {
	type: eDanThuocActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IDanThuocLoadDetailStart {
	type: eDanThuocActionTypeIds.LOAD_DETAIL_START,
	payload: number
}
export interface IDanThuocLoadDetailSuccess {
	type: eDanThuocActionTypeIds.LOAD_DETAIL_SUCCESS,
	payload: DanThuocItemResponse
}
export interface IDanThuocLoadDetailErr {
	type: eDanThuocActionTypeIds.LOAD_DETAIL_ERROR,
	payload: string
}
export interface IDanThuocShowDetail {
	type: eDanThuocActionTypeIds.SHOW_DETAIL,
	payload?: DanThuocItemResponse
}
export interface IDanThuocCloseDetail {
	type: eDanThuocActionTypeIds.CLOSE_DETAIL
}
export interface IDanThuocChangeSelectedIds {
	type: eDanThuocActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IDanThuocChangeSelectedId {
	type: eDanThuocActionTypeIds.CHANGE_SELECTED_ID,
	payload: number
}
export interface IDanThuocShowConfirm {
	type: eDanThuocActionTypeIds.SHOW_CONFIRM,
	payload?: DanThuocItemResponse
}
export interface IDanThuocCloseConfirm {
	type: eDanThuocActionTypeIds.CLOSE_CONFIRM
}
export interface IDanThuocSaveStart {
	type: eDanThuocActionTypeIds.SAVE_START,
	payload: fa_danthuoc
}
export interface IDanThuocSaveSuccess {
	type: eDanThuocActionTypeIds.SAVE_SUCCESS,
	payload: boolean
}
export interface IDanThuocSaveErr {
	type: eDanThuocActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface IDanThuocDeleteStart {
	type: eDanThuocActionTypeIds.DELETE_START,
	payload: number
}
export interface IDanThuocDeleteSuccess {
	type: eDanThuocActionTypeIds.DELETE_SUCCESS
}
export interface IDanThuocDeleteErr {
	type: eDanThuocActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface IDanThuocCapNhatXuLyStart {
	type: eDanThuocActionTypeIds.CAPNHAT_XULY_START,
	payload: IDanThuocCapNhatXuLyPayload
}
export interface IDanThuocCapNhatXuLySuccess {
	type: eDanThuocActionTypeIds.CAPNHAT_XULY_SUCCESS
}
export interface IDanThuocCapNhatXuLyErr {
	type: eDanThuocActionTypeIds.CAPNHAT_XULY_ERROR,
	payload: string
}
export interface IDanThuocLoadChiTietStart {
	type: eDanThuocActionTypeIds.LOAD_CHITIET_START,
	payload: number
}
export interface IDanThuocLoadChiTietSuccess {
	type: eDanThuocActionTypeIds.LOAD_CHITIET_SUCCESS,
	payload: fa_danthuoc_chitiet[]
}
export interface IDanThuocLoadChiTietErr {
	type: eDanThuocActionTypeIds.LOAD_CHITIET_ERROR,
	payload: string
}
export interface IDanThuocShowChiTietDetail {
	type: eDanThuocActionTypeIds.SHOW_CHITIET_DETAIL,
	payload?: fa_danthuoc_chitiet
}
export interface IDanThuocCloseChiTietDetail {
	type: eDanThuocActionTypeIds.CLOSE_CHITIET_DETAIL
}
export interface IDanThuocSaveChiTietStart {
	type: eDanThuocActionTypeIds.SAVE_CHITIET_START,
	payload: fa_danthuoc_chitiet
}
export interface IDanThuocSaveChiTietSuccess {
	type: eDanThuocActionTypeIds.SAVE_CHITIET_SUCCESS,
	payload: boolean
}
export interface IDanThuocSaveChiTietErr {
	type: eDanThuocActionTypeIds.SAVE_CHITIET_ERROR,
	payload: string
}
export interface IDanThuocShowChiTietConfirm {
	type: eDanThuocActionTypeIds.SHOW_CHITIET_CONFIRM,
	payload?: fa_danthuoc_chitiet
}
export interface IDanThuocCloseChiTietConfirm {
	type: eDanThuocActionTypeIds.CLOSE_CHITIET_CONFIRM
}
export interface IDanThuocDeleteChiTietStart {
	type: eDanThuocActionTypeIds.DELETE_CHITIET_START,
	payload: number
}
export interface IDanThuocDeleteChiTietSuccess {
	type: eDanThuocActionTypeIds.DELETE_CHITIET_SUCCESS
}
export interface IDanThuocDeleteChiTietErr {
	type: eDanThuocActionTypeIds.DELETE_CHITIET_ERROR,
	payload: string
}
export interface IDanThuocLoadHinhAnhStart {
	type: eDanThuocActionTypeIds.LOAD_HINHANH_START,
	payload: number
}
export interface IDanThuocLoadHinhAnhSuccess {
	type: eDanThuocActionTypeIds.LOAD_HINHANH_SUCCESS,
	payload: fa_danthuoc_hinhanh[]
}
export interface IDanThuocLoadHinhAnhErr {
	type: eDanThuocActionTypeIds.LOAD_HINHANH_ERROR,
	payload: string
}

export type IDanThuocActionTypes = IDanThuocLoadStart | IDanThuocLoadSuccess | IDanThuocLoadErr |
	IDanThuocLoadDetailStart | IDanThuocLoadDetailSuccess | IDanThuocLoadDetailErr |
	IDanThuocShowDetail | IDanThuocCloseDetail |
	IDanThuocChangeSelectedIds | IDanThuocChangeSelectedId |
	IDanThuocShowConfirm | IDanThuocCloseConfirm |
	IDanThuocSaveStart | IDanThuocSaveSuccess | IDanThuocSaveErr |
	IDanThuocDeleteStart | IDanThuocDeleteSuccess | IDanThuocDeleteErr |
	IDanThuocCapNhatXuLyStart | IDanThuocCapNhatXuLySuccess | IDanThuocCapNhatXuLyErr |
	IDanThuocLoadChiTietStart | IDanThuocLoadChiTietSuccess | IDanThuocLoadChiTietErr |
	IDanThuocShowChiTietDetail | IDanThuocCloseChiTietDetail |
	IDanThuocSaveChiTietStart | IDanThuocSaveChiTietSuccess | IDanThuocSaveChiTietErr |
	IDanThuocShowChiTietConfirm | IDanThuocCloseChiTietConfirm |
	IDanThuocDeleteChiTietStart | IDanThuocDeleteChiTietSuccess | IDanThuocDeleteChiTietErr |
	IDanThuocLoadHinhAnhStart | IDanThuocLoadHinhAnhSuccess | IDanThuocLoadHinhAnhErr
